import { useOutletContext } from 'react-router-dom'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import type { RouteContext } from 'modules/employees/lib/types'
import Cell from 'modules/time_planning/components/Cell'
import CollectionsBootstrap from 'modules/time_planning/lib/EmployeesCollectionsBootstrap'
import { RouteProvider } from 'modules/time_planning/lib/RouteContext'

const Container = observer(() => {
  const { navigation } = useNavigation()
  const { employeeId } = useOutletContext<RouteContext>()

  if (!employeeId) {
    throw new Error('Employee ID is required')
  }

  return (
    <RouteProvider
      baseRoute={{
        planningVersions: (planningVersionId) =>
          navigation.employees.id.planningVersions.planningVersionId.fullPath({
            id: employeeId,
            planningVersionId,
          }),
        index: () => navigation.employees.id.planningVersions.fullPath({ id: employeeId }),
      }}
    >
      <Cell />
    </RouteProvider>
  )
})

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
